<div class="gl-notifications__container">
  <ng-container *ngFor="let job of jobs | keyvalue">
    <lms-job-notifications-messages
      (downloadErrors)="downloadCSV($event)"
      (navUrl)="navUrlLink($event)"
      [jobId]="job.key"
    ></lms-job-notifications-messages>
  </ng-container>
</div>
